import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';
import { Nav, NavParams, MenuController, Events, ModalController, ToastController  } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Camera,CameraOptions } from '@ionic-native/camera';
import { Base64 } from "@ionic-native/base64";
// import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { FileChooser } from '@ionic-native/file-chooser';
import { FilePath } from '@ionic-native/file-path';
import { Diagnostic } from "@ionic-native/diagnostic";

import { Api } from '@providers/api/api';
import { UserMyRadiant as User, PermitProvider } from '../../../providers/';
import { RepositoryMyRadiant, HelperMyRadiant, UtilityMyRadiant} from '../../../providers/';

import { AppPresensi } from '..';
import { UserPresensi } from '../../../providers/presensi';

@Component({
  selector   : 'presensi-add-permit',
  templateUrl: 'page.html'
})
export class AddPermit {
  loading : any;
  formPermit = {
    type   : '',
    date   : '',
    purpose: '',
  };
  configuration_form = {input_employee:false};
  parameter = {
    img_binary        : null,
    file_name         : null,
    permitType        : '',
    date              : '',
    date_to           : '',
    purpose           : '',
    filter_data_permit: '',
    coordinate        : '',
    keterangan        : '',
    id                : this.userApi.data.Employee_ID,
    code              : this.userApi.data.NIK,
    name              : this.userApi.data.Nama_Karyawan,
  };
  data = {
    listType       : [{}],
    alokasiCuti    : {saldo_cuti : 0, day_count_cuti: 0},
    sisa_saldo_cuti: 0,
    preview_img    : './assets/img/no_img.jpg',
    user_position  : {
      lat : 0,
      lng : 0,
    },
  };
  filePermit: any;
  maxRequest = 2;
  
  
  constructor(
    public  navCtrl           : NavController,
    public  menuCtrl          : MenuController,
    public  modalCtrl         : ModalController,
    public  viewCtrl          : ViewController,
    public  nav               : Nav,
    public  navParams         : NavParams,
    public  events            : Events,
    public  config            : Config,
    public  camera            : Camera,
    public  file              : File,
    private fileChooser       : FileChooser,
    private base64            : Base64,
    private filepath          : FilePath,
    private geolocation       : Geolocation,
    private androidPermissions: AndroidPermissions,
    private diagnostic        : Diagnostic,
    public api                : Api,
    public  userApi           : User,
    public  repositoryProvider: RepositoryMyRadiant,
    public  permitProvider    : PermitProvider,
    public  helper            : HelperMyRadiant,
    private userPresensi      : UserPresensi,
    public utility            : UtilityMyRadiant
  ) {
    this.config.set('backButtonText','Leave Input');
    this.getListType();
    this.getAlokasiCuti();
    this.parameter.filter_data_permit = this.userPresensi.akses['add_permit_group_data'];
    this.configuration_form.input_employee =  this.navParams.get('with_employee') === true ? true : false;
  }

  // ionViewWillEnter(){
  //   if (this.utility.buildApk) {
  //     this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.LOCATION).then(
  //       result => this.getPosition(),
  //       err    => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.LOCATION)
  //     );
  //   }
  // }
  ionViewDidEnter(){
    let me = this;
    me.loading = me.helper.showLoading("Getting user data...");
    me.getPosition();

  } 

  getPosition(callback?:any){
    let me = this;
    let watch = me.geolocation.watchPosition();
    try{
      me.geolocation.getCurrentPosition().then((data) => {
        // console.log(data.coords);
        this.data.user_position.lat = data.coords.latitude;
        this.data.user_position.lng = data.coords.longitude;
        me.parameter.coordinate     = data.coords.latitude + "," + data.coords.longitude;
        console.log("Coordinate => ", me.parameter.coordinate);
        me.getAlamatByLatLong(data.coords.latitude,data.coords.longitude);
        // me.loading.dismiss();
        // callback();
      });
    } catch(err){
      me.loading.dismiss();
      me.helper.presentToast("Error"+err);
    }
  }

  getAlamatByLatLong(lat,long){
    let me = this;
    let params  = {
      key     : '1fde645545b1450cbd1a7a1d25d85a8c',
      q       : lat+','+long,
      pretty  : 1
    }
    me.api.getCustomUrl(this.api.url_opencage+'geocode/v1/json',params).subscribe( (openCage:any) =>{
      // console.log(openCage);
      me.maxRequest = me.maxRequest - 1;
      if (me.maxRequest == 0) {
        console.log("maxRequest = ", me.maxRequest);
      }
      try {
        if (openCage.status.code == '200') {
          me.parameter.keterangan = openCage.results[0].formatted;
          console.log("Location => ", me.parameter.keterangan);
          // return out;
        }
      } catch (error) {
        me.helper.presentSwal('','Error',error);
      } finally {
        me.loading.dismiss();
      }
    });
  }

  showCamera(){
    let me = this;
    const options: CameraOptions = {
      quality         : 25,
      destinationType : this.camera.DestinationType.FILE_URI,
      encodingType    : this.camera.EncodingType.JPEG,
      mediaType       : this.camera.MediaType.PICTURE,
      saveToPhotoAlbum: true,
      sourceType      : this.camera.PictureSourceType.CAMERA,
      cameraDirection : this.camera.Direction.FRONT
    }
    
    this.camera.getPicture(options).then((uri) => {
      this.setFile(uri);
      
    }, (err) => {
     // Handle error
    });
  }

  chooseFile(){
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.setFile(uri);
      })
      .catch(e => console.log(e));
  }

  getListType(){
    let me = this;
    this.repositoryProvider.getListPermitType(this.parameter).subscribe((resp:any) => {
      if(resp.success){
        me.data.listType = resp.data;
      }
    },(err) => {
      this.helper.presentSwal('','Error','error');
    }); 
  }

  getAlokasiCuti(){
    let me = this;
    this.repositoryProvider.getCutiAlokasi(this.parameter).subscribe((resp:any) => {
      if(resp.success){
        me.data.alokasiCuti     = resp.data[0];
        me.data.sisa_saldo_cuti = resp.data[0].saldo_cuti - resp.data[0].count_day_cuti;
      }
    },(err) => {
      this.helper.presentSwal('','Error','error');
    }); 
  }

  setFile(url){
    let me = this;
    this.filepath.resolveNativePath(url).then(imageData => {
      me.data.preview_img = imageData;
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {
        me.parameter.file_name = file.name;
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {
        me.parameter.img_binary = base64File;
      }, (err) => {
        console.log(err);
      });
    })
    .catch(err => console.log(err));
  }

  showEmployee(){
    let me = this;
    // console.log(this.userPresensi.akses);
    let params = {
      id: this.userApi.data.Employee_ID,
      all_data : this.userPresensi.akses['add_permit_hak_akses_data'],
    };
    this.helper.filterKaryawan(params, (karyawan) => {
      // console.log(karyawan);
      if (karyawan=='me') {
        me.parameter.name = this.userApi.data.Nama_Karyawan; 
        me.parameter.code = this.userApi.data.NIK;
        me.parameter.id = this.userApi.data.user_id;
      }else{
        me.parameter.name = karyawan.employee_name;
        me.parameter.code = karyawan.nik;
        me.parameter.id   = karyawan.id;
      }
    });
  }

  //method for convert miliseconds to date
  msToDate(t){
    var cd = 24 * 60 * 60 * 1000,
        ch = 60 * 60 * 1000,
        d = Math.floor(t / cd),
        h = Math.floor( (t - d * cd) / ch),
        m = Math.round( (t - d * cd - h * ch) / 60000),
        pad = function(n){ return n < 10 ? '0' + n : n; };
    if( m === 60 ){
      h++;
      m = 0;
    }
    if( h === 24 ){
      d++;
      h = 0;
    }
    // return [d, pad(h), pad(m)].join(':');
    return d;
  }

  submit(){
    let me = this;
    this.loading = this.helper.showLoading("Processing Data...");
    let data = me.parameter;

    //count day
    var day_count = new Date(data.date_to).getTime() - new Date(data.date).getTime();
    day_count = this.msToDate(day_count)+1;

    if(data.permitType == '' || data.date == '' || data.date_to == '' || data.purpose == ''){
      this.helper.presentToast("please complete form !");
      this.loading.dismiss();
      return;
    }
    if(data.permitType == '16' && day_count > this.data.sisa_saldo_cuti){
      this.helper.presentToast("saldo cuti tidak cukup !");
      this.loading.dismiss();
      return;
    }
    if(me.parameter.keterangan==""){
      this.loading.dismiss();
      this.helper.presentToast("Location service not found !");
      return;  
    }

    this.permitProvider.add_permit(data).subscribe((resp:any) => {
      if(resp.success){
        this.helper.presentSwal('Success','Your permit has been inserted','success');
        this.viewCtrl.dismiss();
        this.nav.setRoot(AppPresensi,{tabIndex:2});
        this.loading.dismiss();
      }else{
        this.helper.presentToast("Data process failed !");
        this.loading.dismiss();
      }
    },(err) => {
    }); 
  }

  checkLocationStatus(){
    let locationEnabled = false;
    this.diagnostic
        .isGpsLocationEnabled()
        .then((state) => {
          if (state) {
            locationEnabled = true;
            // do something
            // this.geolocation
            //   .getCurrentPosition()
            //   .then((resp) => {})
            //   .catch((error) => {
            //     console.log("Error getting location", error);
            // });
            // this.getPosition();
          } else {
            // do something else
            let optionsSwal = {
              title     : "Information",
              desc      : "Location access required to complete this form !",
              icon      : "",
              dangerMode: false,
              btnCancel : "Later",
              btnConfirm: "Enable Now",
            };
            this.helper.presentSwalConfirmation(optionsSwal, () => {
              //success callback
              this.diagnostic.switchToLocationSettings();
            });
          }
        })
        .catch((e) => console.error(e));
    return locationEnabled;
  }

}



// WEBPACK FOOTER //
// ./src/pages/presensi/add_permit/page.ts